angular.module('manageSysManageSystemFieldModule', [])
	.controller('manageSysManageSystemFieldCtrl', ['$scope', function($scope){
		console.log("这里是系统字段")
	}]);